<template>
    <div>
        <ReportTemplate
            :loading="!initialized"
            title="Inventory Last Received Report"
            :permission="PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ON_HAND"
            :filters="filters"
            :columns="columns"
            fetchRoute="/reports/inventory-last-received"
            :reportTypeCode="REPORT_MASTER_CODES.INVENTORY_ON_HAND"
        />
    </div>
</template>

<script>
import ReportTemplate from "../ReportTemplate.vue"
import { mapState } from "vuex"
import ReportFilter from "../../../models/ReportFilter"
import { PERMISSION_CODES } from "../../../store/permission"

export default {
    components: { ReportTemplate },
    data() {
        return {
            filters: [],
            initialized: false,
            intervalId: null,
            PERMISSION_CODES,
            columns: [
                { title: "Location", key: "warehouse_name" },
                { title: "Product", key: "item_name" },
                { title: "Batch #", key: "batch_no" },
                { title: "On Hand", key: "on_hand" },
                { title: "Last Received On", key: "last_received_formatted" },
                { title: "Days Since Received", key: "days_since_received" },
            ],
        }
    },
    computed: {
        ...mapState("misc", ["warehouses", "REPORT_MASTER_CODES", "itemGroups"]),
    },
    mounted() {
        this.intervalId = setInterval(() => this.initialize(), 800)
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }
    },
    methods: {
        initialize() {
            if (this.warehouses.length) {
                this.filters.push(
                    new ReportFilter(
                        "Locations",
                        this.warehouses.map(w => ({ id: w.id, title: w.name })),
                        true,
                        "warehouse_ids"
                    ),
                    new ReportFilter(
                        "Classifications",
                        this.itemGroups.map(g => ({ id: g.id, title: g.name })),
                        true,
                        "item_group_ids"
                    ),
                )
                clearInterval(this.intervalId)
                this.initialized = true
            }
        },
    },
}
</script>

<style></style>

